import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import SubscriptionComponent from "../utils/SubscriptionComponent";
import "../../styles/General.css";
import "../../styles/Buttons.css";
import FAQComponent from "../utils/FAQComponent";
import pic from "../../images/facetime-1.jpg";
import CommonServices from "./CommonServices";
import Benefits from "./Benefits";
import { useQRModal } from "../../context/QRModalContext";
import SEO from "../utils/SEO";

const Services = () => {
  const { openQRModal } = useQRModal();
  const redirectToOptions = () => openQRModal();
  return (
    <div className="banner-background">
      <SEO
        title="Talk to a Naturopath, Herbalist or Dietitian Online - Sarv"
        description="Connect with licensed naturopaths, herbalists, and dietitians through video calls and messaging. Get personalized, natural healing strategies from home with Sarv's holistic health practitioners."
        canonicalPath="/services"
        keywords="online naturopath, licensed herbalist online, dietitian video consultation, holistic health practitioner, natural medicine consultation, telehealth herbalist"
      />
      <Container>
        <Row>
          {/* Column for Text */}
          <Col>
            <Row>
              <Col>
                <p className="mission-label">Personalized Holistic Health</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <h1 className="header-agrandir">
                  Experienced licensed practitioners.{" "}
                </h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="mission-text">
                  Sârv, provides a convenient and comprehensive approach to
                  health by connecting individuals with expert naturopaths,
                  herbalists, and dietitians through video calls, and messaging.
                  Our platform allows users to access personalized, natural
                  healing strategies from the comfort of their homes, fostering
                  a deeper understanding of their bodies and promoting a
                  balanced, healthy lifestyle. By integrating various holistic
                  disciplines, Sârv empowers you to take control of your health,
                  offering tailored advice and natural remedies that align with
                  your unique needs and wellness goals.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  className="online-services-btn"
                  onClick={redirectToOptions}
                >
                  Get Started With a Practitioner
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="mission-text">Accessible and affordable</p>
              </Col>
            </Row>
          </Col>

          {/* Column for Picture */}
          <Col>
            <Image
              src={pic}
              style={{
                width: "100%",
                height: "500px",
                margin: "50px",
                borderRadius: "25px",
              }}
              alt="Sarv naturopath consulting with a client over video call"
            />
          </Col>
        </Row>
        {/* <SubscriptionComponent /> */}
      </Container>
      <CommonServices />
      <Benefits />
      <FAQComponent />
      {/* <JoinNewsLetter /> */}
      {/* <SubscriptionComponent /> */}
      {/* <FAQComponent /> */}
    </div>
  );
};

export default Services;
